import { useFormik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import Container from '../../base/Container'
import { CiLocationArrow1 } from 'react-icons/ci'
import { Update, GetById, CheckNewDoctorId, UpdateDoctorId } from '../../../configurations/crud/applicationUserCrud'
import { MdErrorOutline } from 'react-icons/md'
import { IoCheckmarkDoneCircleOutline, IoSearchOutline } from 'react-icons/io5'
import { useToast } from '../../controls/Toast/ToastService'
import { EBoolBg, GetEBool, GetEBoolName } from '../../../configurations/enums/EBool'
import LoadingContainer from '../../controls/LoadingContainer'
import Card from '../../controls/Card'
import { GetEGenderName } from '../../../configurations/enums/EGender'
import StatusContainer from '../../controls/StatusContainer'
import { EApplicationUserStatusBg, GetEApplicationUserStatusName } from '../../../configurations/enums/EApplicationUserStatus'
import { BASE_URL, DOCTOR_URL, FEMALE_DR_AVATAR, MALE_DR_AVATAR } from '../../../configurations/initUrls'
import { UploadDP } from './Settings/UploadDP'
import UpdateUser from './UpdateUser'
import { getLoginInfo } from '../../../configurations/auth/getLoginInfo'
import { UploadHeaders } from './Settings/UploadHeaders'
import Input from '../../controls/Input'
import { FaUserMd } from "react-icons/fa";
import { ProfilePrint } from './Prints/ProfilePrint'
import { PrintStarterDash } from './Prints/PrintStaterDash'
import { UploadFooters } from './Settings/UploadFooters'
import useGlobalLoader from '../../../configurations/useGlobalLoader'

export default function Profile() {
    const { start, end } = useGlobalLoader()
    const [profileData, setProfileData] = useState()
    const [isOpenEdit, setIsOpenEdit] = useState(false)
    const [lodingCrud, setLodingCrud] = useState(false)
    const toast = useToast()
    const loginInfo = getLoginInfo()
    const [isEditing, setIsEditing] = useState(false);
    const [newId, setnewId] = useState()
    const [loading, setLoading] = useState(false)
    const [status, setStatus] = useState(0)

    const [editData, setEditData] = useState({
        userId: loginInfo.id,
        fullName: "",
        degree: "",
        specialisationId: "0",
        experiance: 0,
        gender: 0,
        isOnLeave: 0,
        isSmsActive: 0,
        leaveNote: "",
        cityId: 0,
        address: "",
    })

    const ChangeProfile = (param, setValues) => {
        setLodingCrud(true)
        start()
        Update(param).then(res => {
            let mdata = res.data
            if (mdata.succeeded) {
                setIsOpenEdit(false)
                GetProfile()
                toast.open("Profile has been updated successfully.", <IoCheckmarkDoneCircleOutline />, "success")
            } else {
                toast.open(mdata.message, <MdErrorOutline />, "danger")
            }
            setLodingCrud(false)
            end()
        }).catch(errors => {
            setLodingCrud(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    useEffect(() => {
        GetProfile()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const GetProfile = () => {
        setLodingCrud(true)
        start()
        GetById().then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setProfileData(mdata.data)
            } else {
                setProfileData()
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLodingCrud(false)
            end()
        }).catch(errors => {
            setProfileData()
            setLodingCrud(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    const CheckDrId = () => {
        setLoading(true)
        start()
        CheckNewDoctorId({
            NewDoctorId: newId
        })
            .then(res => {
                let mdata = res.data
                if (mdata.succeeded) {
                    setStatus(1)
                } else {
                    setStatus(2)
                }
                setLoading(false)
                end()
            })
            .catch(errors => {
                setLoading(false)
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            })
    }

    const UpdateDrId = () => {
        setLodingCrud(true)
        start()
        UpdateDoctorId({
            NewDoctorId: newId
        })
            .then(res => {
                let mdata = res.data
                if (mdata.succeeded) {
                    setStatus(0)
                    setIsEditing(false)
                    GetProfile()
                    toast.open(mdata.message, <IoCheckmarkDoneCircleOutline />, "success")
                } else {
                    toast.open(mdata.message, <MdErrorOutline />, "danger")
                }
                setLodingCrud(false)
                end()
            })
            .catch(errors => {
                setLodingCrud(false)
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            })
    }

    const printRef = useRef();

    return (
        <Container title={"Profile"} heading={<>Profile <CiLocationArrow1 /></>}>
            {profileData ? (
                <div className="flex w-full flex-col gap-4 px-2 sm:px-4 md:flex-row md:items-start">

                    {/* ===== Sidebar ===== */}
                    <div className="w-full md:w-3/12 md:sticky md:top-[80px] flex flex-col gap-4">

                        {/* profile card */}
                        <Card isBorder={true} borderColor={EApplicationUserStatusBg(profileData.status).replace("bg", "border")}>
                            <div className="flex flex-col items-center text-center">
                                {profileData && <UploadDP />}
                                <h1 className="mt-2 flex items-center text-xl font-bold leading-8 text-gray-900">Dr. {profileData.fullName}</h1>
                                <h3 className="text-sm text-gray-600">{profileData.userName} ({GetEGenderName(profileData.gender)})</h3>
                                <div className="mt-3 flex items-center gap-2">
                                    <StatusContainer
                                        bg={EApplicationUserStatusBg(profileData.status)}
                                        text={GetEApplicationUserStatusName(profileData.status)}
                                    />
                                    <button
                                        type="button"
                                        title="Update Profile"
                                        onClick={() => {
                                            setEditData({ ...profileData, userId: loginInfo.id });
                                            setIsOpenEdit(!isOpenEdit)
                                        }}
                                        className="rounded-lg bg-brand-500 px-3 py-1 text-xs font-semibold text-white transition hover:bg-brand-600 active:scale-95"
                                    >
                                        Edit
                                    </button>
                                </div>
                            </div>
                        </Card>

                        {/* doctor id card */}
                        {isEditing ? (
                            <Card isBorder={true} title={"Edit Doctor's Id"} borderColor="border-orange-300">
                                <div className="flex flex-col gap-2 text-gray-700">
                                    <a
                                        href={DOCTOR_URL + profileData.doctorId}
                                        target="_blank"
                                        className="break-all text-xs text-blue-700 hover:text-blue-800 hover:underline sm:text-sm"
                                    >
                                        {DOCTOR_URL + profileData.doctorId}
                                    </a>
                                    <div className="flex gap-1">
                                        <Input
                                            Icon={<FaUserMd />}
                                            type="text"
                                            value={newId}
                                            onChange={(e) => setnewId(e.target.value)}
                                            className="w-full rounded border p-2 text-sm"
                                        />
                                        <button
                                            onClick={CheckDrId}
                                            disabled={loading}
                                            className="rounded-lg bg-brand-500 px-3 py-1 text-sm font-medium text-white transition hover:bg-brand-600 active:scale-95 disabled:opacity-60"
                                        >
                                            {loading ? "..." : "Check"}
                                        </button>
                                    </div>
                                    {status == 1
                                        ? <span className="text-sm text-green-600">Available!</span>
                                        : status == 0 ? "" : <span className="text-sm text-red-600">Unavailable!</span>}

                                    <div className="mt-3 flex gap-2">
                                        <button
                                            onClick={UpdateDrId}
                                            disabled={lodingCrud}
                                            className="rounded-lg bg-green-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-green-600 active:scale-95 disabled:opacity-60"
                                        >
                                            {lodingCrud ? "Saving" : "Save"}
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => { setIsEditing(false); setStatus(0) }}
                                            className="rounded-lg bg-gray-500 px-3 py-2 text-sm font-medium text-white transition hover:bg-gray-600 active:scale-95"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </Card>
                        ) : (
                            <Card isBorder={true} title={"Doctor's Id"} borderColor="border-orange-300">
                                <div className="flex flex-col gap-2 text-gray-700">
                                    <a
                                        href={DOCTOR_URL + profileData.doctorId}
                                        target="_blank"
                                        className="break-all text-xs text-blue-700 hover:text-blue-800 hover:underline sm:text-sm"
                                    >
                                        {DOCTOR_URL + profileData.doctorId}
                                    </a>
                                    <div className="mt-3 flex gap-2">
                                        <button
                                            type="button"
                                            onClick={() => { setIsEditing(true); setnewId(profileData.doctorId) }}
                                            className="w-full rounded-lg bg-brand-500 px-2 py-2 text-sm font-medium text-white transition hover:bg-brand-600 active:scale-95"
                                        >
                                            Edit URL
                                        </button>
                                        {profileData &&
                                            <>
                                                <PrintStarterDash text="Print Qr" printRef={printRef} />
                                                <div style={{ display: "none" }}>
                                                    <ProfilePrint data={profileData} ref={printRef} />
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </Card>
                        )}
                    </div>

                    {/* ===== Main ===== */}
                    <div className="flex w-full flex-col gap-4 md:w-9/12">

                        {/* status */}
                        <Card isBorder={true} title={"Doctor's Status"}>
                            <div className="grid grid-cols-1 gap-x-6 sm:grid-cols-2">
                                <InfoRow label="Is On Leave">
                                    <StatusContainer bg={EBoolBg(profileData.isOnLeave)} text={GetEBoolName(profileData.isOnLeave)} />
                                </InfoRow>
                                <InfoRow label="Leave Note">{profileData.leaveNote ? profileData.leaveNote : "N/A"}</InfoRow>
                                <InfoRow label="Is Sms Active">
                                    <StatusContainer bg={EBoolBg(profileData.isSmsActive)} text={GetEBoolName(profileData.isSmsActive)} />
                                </InfoRow>
                            </div>
                        </Card>

                        {profileData.roleName === "Doctor" &&
                            <>
                                <Card isBorder={true} title={"Qualification & Experience"} borderColor="border-brand-300">
                                    <div className="grid grid-cols-1 gap-x-6 sm:grid-cols-2">
                                        <InfoRow label="Specialisation">{profileData.specialisation.name} ({profileData.specialisation.shortName})</InfoRow>
                                        <InfoRow label="Experience">{profileData.experiance} years</InfoRow>
                                        <InfoRow label="Degree">{profileData.degree}</InfoRow>
                                    </div>
                                </Card>

                                <Card isBorder={true} title={"Address"}>
                                    <div className="grid grid-cols-1 gap-x-6 sm:grid-cols-2">
                                        <InfoRow label="Address">{profileData.address}</InfoRow>
                                        <InfoRow label="City">{profileData.city.name}</InfoRow>
                                        <InfoRow label="State">{profileData.city.state.name} ({profileData.city.state.shortName})</InfoRow>
                                    </div>
                                </Card>

                                <Card isBorder={true} title={"Header Image (5:1 | 1000*200 | This Image resolution will be perfect)"}>
                                    {profileData && <div className="w-full"><UploadHeaders /></div>}
                                </Card>

                                <Card isBorder={true} title={"Footer Image (5:1 | 1000*200 | This Image resolution will be perfect)"}>
                                    {profileData && <div className="w-full"><UploadFooters /></div>}
                                </Card>
                            </>
                        }
                    </div>

                    <UpdateUser isOpen={isOpenEdit} setIsOpen={setIsOpenEdit} editData={editData} EditProfileData={ChangeProfile} loding={lodingCrud} />
                </div>
            ) : (
                <div className="w-full">
                    <LoadingContainer text={"Getting doctor's profile"} />
                </div>
            )}
        </Container>
    )
}

/* ---------- helper ---------- */
function InfoRow({ label, children }) {
    return (
        <div className="flex flex-col gap-0.5 border-b border-gray-50 px-1 py-2 sm:flex-row sm:items-center sm:gap-2">
            <div className="text-xs font-semibold uppercase tracking-wide text-gray-400 sm:w-2/5 sm:shrink-0">{label}</div>
            <div className="text-sm text-gray-700 sm:w-3/5">{children}</div>
        </div>
    )
}